export default "__VITE_ASSET__BqDVBWio__"